import { Outlet } from '@tanstack/react-router';

import { useAnalyticsTracking } from '@/lib/analytics';
import { CreateOrderProvider } from '@/views/hooks/create-order-context';

export const RootLayout = () => {
  // Must be used within Router context
  useAnalyticsTracking();

  return (
    <CreateOrderProvider>
      <Outlet />
    </CreateOrderProvider>
  );
};
